import { Component, registerComponent } from "aframe";

const makeAttribute = ( properties : string[], value : any ) =>
{
	const attrValue : { [key:string]:any } = {};
	for(let key of properties)
		attrValue[key] = value;
	return attrValue;
}

interface TextMapData
{
	material : string;
	property : string[];
	size : { x: number, y: number };
	position : { x: number, y: number };
	font : string;
	text : string;
	color : string;
	background : string;
	shadowColor : string;
	shadowBlur : number;
	shadowOffset : { x:number, y:number };
	stroke : string;
	align : string;
	baseline : string;
	lineHeight : number;
	case : string;
}
interface TextMapComponent extends Component
{
	data : TextMapData;
}


const getCaseTransform = (type : string) =>
{
	if(type == "upper") return (s : string) => s.toUpperCase();
	if(type == "lower") return (s : string) => s.toLowerCase();
	return (s : string) => s;
}

const functionRegex = /^(?<name>[^\(]+)\((?<args>[^\)]+)\)(?:\.(?<rest>.+))?/;
const trim = (s : string) => s.trim();

registerComponent("text-map", {
	multiple : true,
	schema : {
		material : { type : "string", default : "" },
		property : { type : "array", default : ["src"] },
		size : { type : "vec2", default : { x : 256, y : 256 }},
		position : { type : "vec2", default : { x : 0.5, y : 0.5 } },
		font : { type : "string", default : "32px serif" },
		text : { type : "string" },
		color : { type : "string", default : "#000000FF" },
		background : { type : "string", default : "#FFFFFFFF" },
		shadowColor : { type : "string", default : "" },
		shadowBlur : { type : "number", default : 0 },
		shadowOffset : { type : "vec2" , default : { x:0, y:0 } },
		stroke : { type : "string", default : "" },
		align : { type : "string", default : "center" },
		baseline : { type : "string", default : "middle" },
		lineHeight : { type : "int", default : 32 },
		case : { type : "string", default: "" } //upper/lower
	},
	init(this : TextMapComponent)
	{
		//this.canvas = this.el.ownerDocument.createElement("canvas");
	},
	remove(this : TextMapComponent)
	{
		if( !this.el.isConnected ) return; //Destroyed.
		
		const defaultMat = this.id ? ("material__" + this.id) : "material";
		const targetMat = this.data.material || defaultMat;
		this.el.setAttribute(targetMat, makeAttribute(this.data.property, null) );
	},
	update(this : TextMapComponent, old : TextMapData)
	{
		const defaultMat = this.id ? ("material__" + this.id) : "material";

		const targetMat = this.data.material || defaultMat;

		if(old && (old.material !== undefined) && (old.property !== undefined))
		{
			const oldMat = (old.material || defaultMat);
			const oldProp = old.property;
			if((oldMat != targetMat) || (oldProp.join(";") != this.data.property.join(";")))
				this.el.setAttribute(oldMat, makeAttribute(oldProp, null));
		}

		const W = this.data.size.x, H = this.data.size.y;

		const canvas = this.el.ownerDocument.createElement("canvas");
		canvas.width = W;
		canvas.height = H;

		//canvas.style.setProperty('font-smooth', 'never');
		//canvas.style.setProperty("-webkit-font-smoothing", "none");


		const ctx = canvas.getContext('2d')!;

		let bg : any = this.data.background;
		let match = bg.match(functionRegex)?.groups;
		if(match && (match.name in ctx))
		{
			let fn = (ctx as any)[ match.name ] as Function;
			let args = match.args.split(',').map(trim);
			bg = fn.apply(ctx, args);

			while(match.rest && bg && (match = match.rest.match(functionRegex)?.groups) && (match.name in bg))
			{
				fn = (bg as any)[ match.name ] as Function;
				args = match.args.split(',').map(trim);
				bg = fn.apply(bg, args) || bg;
			}
		}
		
		ctx.fillStyle = bg;
		ctx.fillRect(0, 0, W, H);

		ctx.font = this.data.font;
		ctx.textAlign = this.data.align as CanvasTextAlign;
		ctx.textBaseline = this.data.baseline as CanvasTextBaseline;

		if(this.data.shadowColor)
		{
			ctx.shadowColor = this.data.shadowColor;
			ctx.shadowBlur = this.data.shadowBlur;
			ctx.shadowOffsetX = this.data.shadowOffset.x;
			ctx.shadowOffsetY = this.data.shadowOffset.y;
		}

		const lines = this.data.text.split("\n").map(getCaseTransform(this.data.case));
		
		let x = this.data.position.x * W, y = this.data.position.y * H - 0.5 * (lines.length - 1) * this.data.lineHeight ;
		for(let line of lines)
		{
			if(this.data.color)
			{
				ctx.fillStyle = this.data.color;
				ctx.fillText(line, x, y);
			}
			if(this.data.stroke)
			{
				ctx.strokeStyle = this.data.stroke;
				ctx.strokeText(line, x, y);
			}
			y += this.data.lineHeight;
		}

		this.el.setAttribute(targetMat, makeAttribute( this.data.property, canvas ) );
	}
})